import { useMemo } from "react"
import { useQuery } from "@rocicorp/zero/react"

import { queries } from "@productlane/zero/queries"

import type { SecureRefOption } from "./secure-ref-picker"

/**
 * Connector titles by section id, for the pins that stand in for an id. The synced
 * rows come first because they are right on the first frame, while the ref catalog
 * takes a round trip to every connector and names none that returned no refs.
 */
export function useConnectorTitles(
	options: readonly SecureRefOption[] = [],
): Readonly<Record<string, string>> {
	const [connectors] = useQuery(queries.sidebarSections())

	return useMemo(() => {
		const titles: Record<string, string> = {}
		for (const option of options) {
			if (option.sectionId && option.connectorTitle) {
				titles[option.sectionId] = option.connectorTitle
			}
		}
		for (const connector of connectors) {
			titles[connector.id] = connector.title
		}
		return titles
	}, [connectors, options])
}
